<template>
  <div class="GlobalFormDemo">
    <GlobalForm :init-data="initData" :form-item-list="formItemList" :inline="true" :labelWidth="90" round :needBtnLoading="true"
      @handleConfirm="handleConfirm" confirmBtnName="查询">
      <el-form-item class="el_from" label="用户电话" slot="userPhone">
        <el-input clearable size="small" v-model.trim="userPhone" oninput="this.value=value.replace(/[^0-9]/g,'')"
          placeholder="请输入用户电话"></el-input>
      </el-form-item>
      <el-form-item class="el_from" label="订单状态" slot="states">
        <el-select v-model="states" multiple collapse-tags placeholder="请选择">
          <el-option v-for="item in option" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="el_from" label="状态标记" slot="stateStamps">
        <el-select v-model="stateStamps" placeholder="请选择" clearable>
          <el-option v-for="item in option2" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="el_from" label="受理门店" slot="storeName">
        <el-select v-model="storeName" placeholder="请选择" clearable>
          <el-option v-for="item in storeList" :key="item.key" :label="item.value" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <div slot="AddSlot">
        <el-button size="small" type="success" :loading="exportLoading" icon="el-icon-download" @click="exportTable()">导出Excel</el-button>
      </div>
    </GlobalForm>
  </div>
</template>

<script>
import _api from "@/utils/request";
import moment from "moment";
export default {
  name: "Form",
  props: {
    accountType: {
      require: true,
      type: String,
    },
  },
  data() {
    return {
      initData: {
        orderTime: [
          moment().day(moment().day()-30).format("YYYY-MM-DD 00:00:00"),
          moment().format("YYYY-MM-DD 23:59:59"),
        ],
      },
      userPhone: "",
      states: [],
      stateStamps: "",
      storeName: "",
      storeList: [],
      option: [
        {
          value: "01",
          label: "已接单",
        },

        {
          value: "02",
          label: "待回收",
        },
        {
          value: "03",
          label: "已完成",
        },
        {
          value: "04",
          label: "已取消",
        },
        {
          value: "05",
          label: "已退回",
        },
      ],
      option2: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "01",
          label: "等待上门",
        },
        {
          value: "02",
          label: "等待顾客到店",
        },
        {
          value: "03",
          label: "未下回收单",
        },
        {
          value: "04",
          label: "已下回收单",
        },
        {
          value: "05",
          label: "已完成",
        },
        {
          value: "06",
          label: "超时系统取消",
        },
        {
          value: "07",
          label: "顾客取消",
        },
        {
          value: "08",
          label: "员工操作取消",
        },
        {
          value: "09",
          label: "回收单作废",
        },
        {
          value: "10",
          label: "回收单退回",
        },
      ],
      formItemList: [
        {
          key: "recycleType",
          type: "select",
          lableWidth: "100px",
          labelName: "订单类型",
          option: [
            {
              value: "",
              label: "全部",
            },
            {
              value: "01",
              label: "上门回收",
            },

            {
              value: "02",
              label: "到店回收",
            },
          ],
        },
        {
          key: "customerOrderNo",
          type: "input",
          labelName: "订单号",
          placeholder: "请输入订单号",
        },
        // {
        //   key: "states",
        //   type: "select",
        //   lableWidth: "100px",
        //   labelName: "订单状态",
        //   option: [
        //     {
        //       value: "",
        //       label: "全部",
        //     },
        //     {
        //       value: "01",
        //       label: "已接单",
        //     },

        //     {
        //       value: "02",
        //       label: "待回收",
        //     },
        //     {
        //       value: "03",
        //       label: "已完成",
        //     },
        //     {
        //       value: "04",
        //       label: "已取消",
        //     },
        //     {
        //       value: "05",
        //       label: "已退回",
        //     },
        //   ],
        // },
        { slotName: "states" },
        { slotName: "stateStamps" },
        // {
        //   key: "stateStamps",
        //   type: "select",
        //   lableWidth: "100px",
        //   labelName: "状态标记",
        //   option: [
        //     {
        //       value: "",
        //       label: "全部",
        //     },
        //     {
        //       value: "01",
        //       label: "等待上门",
        //     },
        //     {
        //       value: "02",
        //       label: "等待顾客到店",
        //     },
        //     {
        //       value: "03",
        //       label: "未下回收单",
        //     },
        //     {
        //       value: "04",
        //       label: "已下回收单",
        //     },
        //     {
        //       value: "05",
        //       label: "已完成",
        //     },
        //     {
        //       value: "06",
        //       label: "超时系统取消",
        //     },
        //     {
        //       value: "07",
        //       label: "顾客取消",
        //     },
        //     {
        //       value: "08",
        //       label: "员工操作取消",
        //     },
        //     {
        //       value: "09",
        //       label: "回收单作废",
        //     },
        //     {
        //       value: "10",
        //       label: "回收单退回",
        //     },
        //   ],
        // },
        {
          key: "finishTime",
          type: "daterange",
          labelName: "成交时间",
          valueFormat: "timestamp",
        },
        { slotName: "storeName" },

        // {
        //   key: "storeName",
        //   type: "input",
        //   labelName: "受理门店",
        //   placeholder: "请输入受理门店",
        // },
        {
          key: "userName",
          type: "input",
          labelName: "用户姓名",
          placeholder: "请输入用户姓名",
        },

        { slotName: "userPhone" },
        {
          key: "orderTime",
          type: "pickerOptions",
          labelName: "下单时间",
          valueFormat: "timestamp",
          clearable: true,
        },
        {
          key: "arriveTime",
          type: "daterange",
          labelName: "预约时间",
          valueFormat: "timestamp",
        },

        // {
        //   key: "userPhone",
        //   type: "input",
        //   labelName: "用户电话",
        //   placeholder: "请输入用户电话",
        // },
      ],
      seachParams: null,
      exportLoading: false
    };
  },
  created() {
    if (this.$route.query.mobile) {
      this.userPhone = this.$route.query.mobile;
    }
    this.handleConfirm(this.initData);
    _api.getStoreSelectOrder().then((res) => {
      this.storeList = res.data;
    });
  },
  watch: {},
  methods: {
    handleConfirm(data,cd) {
      // console.log(data);
      let SeachParams = {};
      console.log(this.userPhone);
      if (data) {
        SeachParams = {
          recycleType: data.recycleType,
          states: this.states,
          stateStamps: this.stateStamps ? [this.stateStamps] : [],
          storeName: this.storeName,
          orderStartTime: data.orderTime ? moment(data.orderTime[0]).format("x") : "",
          orderEndTime: data.orderTime ? moment(data.orderTime[1]).format("x") : "",
          userName: data.userName,
          userPhone: this.userPhone,
          arriveStartTime: data.arriveTime ? data.arriveTime[0] : "", //预约开始时间
          arriveEndTime: data.arriveTime ? data.arriveTime[1] : "", //预约结束时间
          finishStartTime: data.finishTime ? data.finishTime[0] : "", //完成开始时间
          finishEndTime: data.finishTime ? data.finishTime[1] : "", //完成结束时间
          customerOrderNo: data.customerOrderNo,
          pageNum: 1,
          pageSize: 10,
        };
      }
      console.log(this.userPhone);
      SeachParams.userPhone = this.userPhone;
      this.seachParams = JSON.parse(JSON.stringify(SeachParams));
      SeachParams.disuseLoding = () => {
        if (typeof cd === 'function') {
          cd()
        }
      },
      console.log("提交了form", SeachParams);
      this.$store.commit("tagsView/SEACH_PARAMS", SeachParams);
    },
    exportTable() {
      this.seachParams.pageNum = 1;
      this.seachParams.pageSize = 999999;
      this.exportLoading = true
      _api.assessOrderExcel(this.seachParams).then((res) => {
        console.log(res);
        const content = res;
        const blob = new Blob([content]);
        let reader = new FileReader(); // 创建读取文件对象
        reader.addEventListener("loadend", () => {
          try {
            let data = JSON.parse(reader.result);
            if (data.code === 0) {
              this.$message.error(data.msg || "服务异常");
            }
          } catch (err) {
            const fileName = "线上订单.xlsx";
            if ("download" in document.createElement("a")) {
              // 非IE下载
              const elink = document.createElement("a");
              elink.download = fileName;
              elink.style.display = "none";
              elink.href = URL.createObjectURL(blob);
              document.body.appendChild(elink);
              elink.click();
              URL.revokeObjectURL(elink.href); // 释放URL 对象
              document.body.removeChild(elink);
            } else {
              // IE10+下载
              navigator.msSaveBlob(blob, fileName);
            }
          }
        });
        reader.readAsText(blob, "utf-8");
      }).finally(() => {
        this.exportLoading = false
      });
    },
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.GlobalFormDemo {
  .mb-10 {
    margin-bottom: 10px;
  }

  .mt-10 {
    margin-top: 10px;
  }

  .mt-20 {
    margin-top: 20px;
  }

  .mb-20 {
    margin-bottom: 20px;
  }

  .mr-50 {
    margin-right: 50px;
  }

  .ml-10 {
    margin-left: 10px;
  }

  .mr-10 {
    margin-right: 10px;
  }

  .font-w {
    font-weight: bold;
  }

  .flex {
    display: flex;
    align-items: center;
  }

  .flexwarp {
    display: flex;
    flex-wrap: wrap;
  }

  .flex-jb {
    display: flex;
    justify-content: space-between;
  }

  .flex-as {
    display: flex;
    align-items: flex-start;
  }

  .flex-je {
    display: flex;
    justify-content: flex-end;
  }

  .label {
    white-space: nowrap;
    margin-right: 10px;
    width: 56px;
  }

  .images-box {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .images-box>span {
    color: #0981ff;
    cursor: pointer;
  }

  .text-down {
    color: #0981ff;
    cursor: pointer;
    text-decoration: underline;
  }

  /deep/input::-webkit-inner-spin-button {
    display: none !important;
  }
}
</style>
